/* Native Shopify contact submission is left intact, including Shopify spam protection.
   No answers are stored in localStorage, cookies, query strings, or third-party services. */
(() => {
  if (customElements.get('fyr-coaching-form')) return;
  class FYRCoachingForm extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      const form = this.querySelector('form');
      if (!form) return;
      const success = this.querySelector('[data-fyr-success]');
      if (success) { success.focus({ preventScroll: true }); return; }
      const groups = [...form.querySelectorAll('[data-fyr-checkbox-group]')];
      const otherToggle = form.querySelector('[data-fyr-other-toggle]');
      const otherText = form.querySelector('[data-fyr-other-text]');
      const validation = form.querySelector('[data-fyr-validation]');
      let attempted = false;
      // Safe source classification only. No personal or order data in the URL.
      const sourceField = form.querySelector('[data-fyr-entry-source]');
      const source = new URLSearchParams(window.location.search).get('source');
      const labels = { 'thank-you': 'Shopify Thank You page', 'order-status': 'Shopify Order status page' };
      if (sourceField) sourceField.value = Object.prototype.hasOwnProperty.call(labels, source) ? labels[source] : 'Website';
      const syncOther = () => {
        if (!otherToggle || !otherText) return;
        otherText.disabled = !otherToggle.checked;
        otherText.required = otherToggle.checked;
        otherText.setCustomValidity(otherToggle.checked && !otherText.value.trim() ? 'Please specify the other help you would like.' : '');
      };
      const checkGroups = (showErrors = false) => {
        let valid = true;
        groups.forEach(group => {
          const boxes = [...group.querySelectorAll('input[type="checkbox"]')];
          const hasSelection = boxes.some(box => box.checked);
          if (boxes[0]) boxes[0].setCustomValidity(hasSelection ? '' : 'Select at least one option.');
          const message = group.querySelector('.fyr-coaching__field-error');
          if (message) message.hidden = hasSelection || !showErrors;
          valid = valid && hasSelection;
        });
        return valid;
      };
      const checkWhitespace = () => {
        form.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"]), textarea[required]').forEach(input => {
          if (input === otherText || input.disabled) return;
          input.setCustomValidity(input.value.trim() ? '' : 'Please answer this question.');
        });
      };
      const refresh = () => {
        syncOther();
        checkGroups(attempted);
        checkWhitespace();
        form.querySelectorAll('[aria-invalid="true"]').forEach(input => {
          if (input.validity.valid) input.removeAttribute('aria-invalid');
        });
      };
      syncOther();
      checkGroups();
      // Provide consistent group-level validation; keep a native no-JS fallback.
      form.noValidate = true;
      form.addEventListener('input', refresh, { signal });
      form.addEventListener('change', refresh, { signal });
      form.addEventListener('submit', event => {
        attempted = true;
        refresh();
        if (!form.checkValidity()) {
          event.preventDefault();
          if (validation) validation.hidden = false;
          const invalid = [...form.querySelectorAll('input, textarea')].filter(input => input.willValidate && !input.validity.valid);
          invalid.forEach(input => input.setAttribute('aria-invalid', 'true'));
          invalid[0]?.focus();
          invalid[0]?.reportValidity();
          return;
        }
        if (validation) validation.hidden = true;
        // IMPORTANT: do not preventDefault here, fetch elsewhere, show a fake
        // success message, or disable the submit button before Shopify handles it.
      }, { signal });
    }
    disconnectedCallback() { this.abortController?.abort(); }
  }
  customElements.define('fyr-coaching-form', FYRCoachingForm);
})();
